export default __webpack_public_path__ + "static/media/tram.inline.2980eb38.svg";